import { nextPathId } from "../definition-model";
import type { ExitRef } from "../exit-slots";
import { wouldLoopWithoutWait } from "../graph-check";
import type { Definition } from "../types";
import { TRIGGER_TILE } from "./canvas-layout";

/** Why a connector cannot end where the author dropped it. */
export type RefusalReason = "self" | "loop" | "trigger" | "full";

export type ConnectCheck = { ok: true } | { ok: false; reason: RefusalReason };

const OK: ConnectCheck = { ok: true };
const refuse = (reason: RefusalReason): ConnectCheck => ({ ok: false, reason });

/**
 * Whether an exit may lead to a tile. `tileId` is a path, the trigger tile, or `null` for a path the drop would create
 * (refused while all 26 paths exist). The path an exit sits on, the trigger, and a target that would make the path loop
 * without waiting for the visitor are refused.
 */
export function connectTarget(definition: Definition, source: ExitRef, tileId: string | null): ConnectCheck {
  if (tileId === null) return nextPathId(definition) === null ? refuse("full") : OK;
  if (tileId === TRIGGER_TILE) return refuse("trigger");
  if (tileId === source.path) return refuse("self");
  return wouldLoopWithoutWait(definition, source, source.key, tileId) ? refuse("loop") : OK;
}
